<template>
  <section :class="$style.container">
    <Wrapper :class="$style.inner">
      <div :class="$style.mainContainer">
        <Title :class="$style.title" :title-params="primary.title" />
        <RichText
          :class="$style.description"
          :text-params="primary.description"
        />
        <ArrowButton
          v-if="primary.cta_title && primary.cta_url"
          :href="primary.cta_url"
          :class="$style.cta"
          is-outlined
          target="_blank"
          class="icon-gray-1000"
        >
          {{ primary.cta_title }}
        </ArrowButton>
      </div>
      <aside :class="$style.carouselContainer">
        <VueSlickCarousel
          v-bind="{ arrows: false, autoplay: true, autoplaySpeed: 8000 }"
          ref="carousel"
        >
          <div v-for="item in items" :key="item.id">
            <component
              :is="hasLink(item.ctalink) ? 'a' : 'div'"
              :href="
                hasLink(item.ctalink)
                  ? getFormatedLink(item.ctalink)
                  : undefined
              "
              :target="hasLink(item.ctalink) ? '_blank' : undefined"
            >
              <PImage
                :image-object="item.image"
                sizes="sm:150vw"
                :class="$style.itemImage"
              />
            </component>
            <div :class="$style.itemCaption">
              <div :class="$style.iconContainer" @click="go(-1)">
                <ChevronLeftIcon class="icon-white" :class="$style.icon" />
              </div>
              <div :class="$style.textContainer">
                <Title :title-params="item.title" :class="$style.itemTitle" />
                <RichText
                  :text-params="item.description"
                  :class="$style.itemDescription"
                />
              </div>
              <div :class="$style.iconContainer" @click="go(1)">
                <ChevronRightIcon class="icon-white" :class="$style.icon" />
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </aside>
    </Wrapper>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import ChevronLeftIcon from 'LkIcons/ChevronLeft.vue'
import ChevronRightIcon from 'LkIcons/ChevronRight.vue'

import { getFormatedLink } from '~/mixins/getFormatedLink'
import ArrowButton from '~/components/ArrowButton'

export default {
  name: 'AssociationsCarousel',
  components: {
    ArrowButton,
    ChevronLeftIcon,
    ChevronRightIcon,
    VueSlickCarousel,
  },
  mixins: [getFormatedLink],
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      primary: this.slice.primary,
      items: this.slice.items,
      activeSlide: 0,
      carousel: null,
    }
  },
  methods: {
    go(direction) {
      if (direction < 0) this.$refs.carousel.prev()
      else this.$refs.carousel.next()
    },
    hasLink(linkObject) {
      return linkObject && linkObject.url
    },
  },
}
</script>

<style lang="scss" module>
.container {
  @include below(large) {
    margin: 0 5%;
  }
  @include below(small) {
    margin: 0;
  }
}
.inner {
  display: flex;
  max-width: 1440px;
  @include below(large) {
    flex-direction: column;
  }
}
.mainContainer {
  display: flex;
  flex: 1 1 50%;
  flex-direction: column;
  justify-content: center;
  padding: 0 80px;

  background-color: $orange-50;
  @include below(large) {
    padding: 60px;
  }
  @include below(small) {
    padding: 24px;
  }
}
.carouselContainer {
  flex: 1 0 50%;
  min-width: 680px;

  background-color: #2d50e6;
  @include below(large) {
    min-width: unset;
  }
}

.title {
  font-weight: 200;
  font-size: 48px;
  line-height: 55px;
  @include below(small) {
    font-size: 36px;
    line-height: 48px;
  }
}
.description {
  @include typo-body;
  margin-top: 16px;
}
.cta {
  width: max-content;
  margin-top: 64px;
  border: 2px solid black !important;

  color: black !important;
  &:hover {
    background-color: rgba(0, 0, 0, 0.2) !important;
  }

  @include below(large) {
    width: 100%;
  }
}
.itemCaption {
  display: flex;
  width: 100%;
  padding: 26px 0;

  text-align: left;

  background-color: #2d50e6;
  a {
    color: white;
  }
  @include below(large) {
    height: unset;
  }
}

.itemTitle {
  color: white;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
}
.itemDescription {
  color: white;
  font-size: 16px;
  line-height: 24px;
}

.itemImage {
  width: 100%;
  height: 500px;
  object-fit: cover;
  @include below(medium) {
    height: 400px;
  }
  @include below(small) {
    height: 300px;
  }
}
.iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10%;

  cursor: pointer;
}
.icon {
  width: 100%;
}
.textContainer {
  width: 80%;
  padding: 0 10px;
}
</style>
